// extracted by mini-css-extract-plugin
export default {"root":"hYrkftP2","brandingLink":"_2aEFt8i9","wobble":"tWA33D9M","logo":"_1VoXP2w-","arrowIcon":"_3mHA2sZy"};